"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkBuilder = void 0;
var LinkBuilder;
(function (LinkBuilder) {
    class LinkBuilderController {
        static getQueryParam(name) {
            return this.getQueryParamFromString(name, window.location.search);
        }
        static getViewTypeFromString(uriString) {
            const viewTypeRaw = this.getQueryParamFromString('viewType', uriString);
            return viewTypeRaw ? parseInt(viewTypeRaw) : null;
        }
        static getQueryParamFromString(name, uriString) {
            const urlParams = new URLSearchParams(uriString);
            const param = urlParams.get(name);
            if (param === null) {
                return null;
            }
            return param;
        }
        static getQueryParamRequired(name) {
            const value = this.getQueryParam(name);
            if (value === null) {
                throw new Error('Impossible to find parameter: ' + name);
            }
            return value;
        }
        static getViewType() {
            const viewTypeRaw = this.getQueryParam('viewType');
            if (viewTypeRaw === null) {
                return null;
            }
            return parseInt(viewTypeRaw);
        }
        static setViewType(viewType) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            urlParams.set('viewType', viewType.toString());
            const urlWithoutParams = location.protocol + '//' + location.host + location.pathname;
            const urlWithParams = urlWithoutParams + '?' + urlParams.toString();
            window.history.pushState({ viewType: viewType }, 'title', urlWithParams);
        }
        static composeLink({ modulePresenter, component, method, parameters }) {
            const componentString = component ? component + "-" : "";
            const methodString = method ? `do=${componentString}${method}` : "";
            let presenterString;
            if (modulePresenter) {
                presenterString = `${modulePresenter.module}.${modulePresenter.presenter}`;
            }
            else {
                const location = new URL(window.location.href.split("#")[0]);
                for (const parameter of parameters) {
                    location.searchParams.delete(`${componentString}${parameter.name}`);
                }
                presenterString = decodeURI(location.href);
            }
            let parametersString = "";
            if (parameters) {
                for (let i = 0; i < parameters.length; i++) {
                    const parameter = parameters[i];
                    if (!Array.isArray(parameter.value)) {
                        continue;
                    }
                    parameters.splice(i, 1);
                    for (let j = 0; j < parameter.value.length; j++) {
                        const parameterItem = parameter.value[j];
                        parameters.push({ name: `${parameter.name}[${j}]`, value: parameterItem });
                    }
                }
                let counter = 0;
                parameters
                    .filter((element) => { return element.value !== null; })
                    .forEach((element) => {
                    const stringValue = typeof element.value === "boolean"
                        ? (element.value ? 1 : 0)
                        : element.value.toString();
                    parametersString += counter > 0 ? "&" : "";
                    parametersString += `${componentString}${element.name}=${stringValue}`;
                    ++counter;
                });
            }
            let output = `${presenterString}`;
            output += parametersString.length > 0 ? `${output.includes('?') ? '&' : '?'}${parametersString}` : '';
            output += methodString.length > 0 ? `${output.includes('?') ? '&' : '?'}${methodString}` : '';
            return encodeURI(output);
        }
    }
    LinkBuilder.LinkBuilderController = LinkBuilderController;
})(LinkBuilder || (exports.LinkBuilder = LinkBuilder = {}));
